// <giveaway-countdown data-end="YYYY-MM-DD HH:MM"> ... [data-d][data-h][data-m][data-s] ... </giveaway-countdown>
// Updates the four unit values once per second and hides itself once the end date passes.
class GiveawayCountdown extends HTMLElement {
  connectedCallback() {
    const raw = (this.dataset.end || "").replace(" ", "T");
    this.end = new Date(raw).getTime();
    if (isNaN(this.end)) return;

    this.dEl = this.querySelector("[data-d]");
    this.hEl = this.querySelector("[data-h]");
    this.mEl = this.querySelector("[data-m]");
    this.sEl = this.querySelector("[data-s]");

    this.tick();
    this.timer = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  tick() {
    const diff = this.end - Date.now();
    if (diff <= 0) {
      this.hidden = true;
      clearInterval(this.timer);
      return;
    }
    this.hidden = false;
    if (this.dEl) this.dEl.textContent = Math.floor(diff / 86400000);
    if (this.hEl) this.hEl.textContent = Math.floor((diff % 86400000) / 3600000);
    if (this.mEl) this.mEl.textContent = Math.floor((diff % 3600000) / 60000);
    if (this.sEl) this.sEl.textContent = Math.floor((diff % 60000) / 1000);
  }
}

customElements.define("giveaway-countdown", GiveawayCountdown);
